import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=42b7b6ce&scoped=true"
import script from "./PageHome.vue?vue&type=script&lang=js"
export * from "./PageHome.vue?vue&type=script&lang=js"
import style0 from "./PageHome.vue?vue&type=style&index=0&id=42b7b6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b7b6ce",
  null
  
)

export default component.exports